import type { Resource } from '../../';
export const country_countries_CA: Resource = {"default":"Canada"};
